import React, { Component } from 'react';
import { Translate } from '_translations';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

class LanguageSelector extends Component {
  constructor() {
    super();

    this.state = {
      isOpen: false,
    };

    this.languageSelectorRef = React.createRef();
  }

  render() {
    if (!this.props.languages) {
      return null;
    }

    return (
      <div className="language-selector">
        <div className="current-language" onClick={this.handleToggleClick}>
          <span className={`flag ${this.getCurrentCulture().cultureCode}`}></span>
        </div>
        <div className={`language-overlay ${this.state.isOpen ? 'active' : ''}`} onClick={this.handleToggleClick}></div>
        <div className={`language-grid ${this.state.isOpen ? 'active' : ''}`} ref={this.languageSelectorRef}>
          <div className="language-grid-inner">
            {this.props.languages.map(x =>
              <a key={x.cultureCode} className="language-grid-item" href={`/${x.alias}/`}>
                <span className={`flag ${x.cultureCode}`}></span>
                <span className="flag-title"><Translate resourceString={x.resourceString} /></span>
              </a>)
            }
            <div className="language-grid-close" onClick={this.handleToggleClick}></div>
          </div>
        </div>
      </div>
    );
  }

  handleToggleClick = () => {
    const isOpen = !this.state.isOpen;


    if (isOpen && window.matchMedia('(max-width: 991px)').matches) {
      disableBodyScroll(this.languageSelectorRef.current);
    } else {
      enableBodyScroll(this.languageSelectorRef.current);
      clearAllBodyScrollLocks();
    }

    this.setState({
      isOpen,
    });
  }

  getCurrentCulture = () => {
    let toReturn = this.props.languages.find(x => x.cultureCode.toLowerCase() === this.props.cultureCode.toLowerCase());

    if (toReturn === undefined) {
      toReturn = this.props.languages.find(x => x.cultureCode.toLowerCase() === 'en-tt');
    }

    if (toReturn === undefined) {
      toReturn = {
        cultureCode: 'en-tt',
      };
    }

    return toReturn;
  }
}

export default LanguageSelector;
